import { SpaceProps } from "antd/lib/space";
import cn from "classnames";
import { Children, PropsWithChildren, ReactNode, useMemo } from "react";

import styles from "./SpaceSeparator.module.scss";

type SpaceSeparatorProps = SpaceProps & {
  separator:
    | "comma"
    | "verticalBar"
    | "dot"
    | "space"
    | "slash"
    | "arrowRight"
    | "hyphen";
  placeholder?: ReactNode;
  inline?: boolean;
  wrap?: boolean;
  className?: string;
  itemClassName?: string;
  ellipsis?: boolean;
};

export const SpaceSeparator: React.FC<
  PropsWithChildren<SpaceSeparatorProps>
> = ({
  children: childrenRaw,
  separator = "dot",
  placeholder,
  inline = true,
  wrap = true,
  className,
  itemClassName,
  ellipsis = true,
}) => {
  const children = useMemo(() => {
    return Children.toArray(childrenRaw).filter((x) => !!x);
  }, [childrenRaw]);

  if (children.length === 0) return placeholder ?? null;

  return (
    <div
      className={cn(styles.space_separator, className)}
      data-wrap={wrap}
      data-inline={inline}
      data-separator={separator}
      data-ellipsis={ellipsis}
    >
      {children.map((x, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} className={cn(styles.item, itemClassName)}>
          {x}
        </div>
      ))}
    </div>
  );
};
